import { useEffect, useState } from "react";
import Picker from "react-mobile-picker";
export type SliderPickerProps = {
  options: {
    type: "day" | "hour" | "minutes";
    defaultValue: string;
    cb(value: string): void;
    /**
     * 是否无限
     */
    isInf?: boolean
    disabled?: boolean
  };
};
function SliderPicker(props: SliderPickerProps) {
  // 区分day hour minutes

  const { options } = props;
  // picker 日期初始数据
  let datas = [];
  props.options.isInf && datas.push("∞")
  if (options.type === "day") {
    for (let i = 0; i < 31; i++) {
      datas.push(i.toString());
    }
  }

  if (options.type === "hour") {
    for (let i = 0; i <= 24; i++) {
      datas.push(i.toString());
    }
  }

  if (options.type === "minutes") {
    for (let i = 0; i <= 55; i += 5) {
      datas.push(i.toString());
    }
  }




  const pickerData = {
    data: datas,
  };

  const [pickerValue, setPickerValue] = useState({
    data: options.defaultValue,
  });

  function onChangePicker(data: any) {
    options.cb(data.data);
  }

  // 重置组件
  useEffect(() => {
    setPickerValue({
      data: options.defaultValue,
    });
  }, [options.defaultValue]);

  return (
    <Picker
      value={pickerValue}
      onChange={onChangePicker}
      height={240}
      itemHeight={70}
      style={{
        pointerEvents: options.disabled ? "none" : "auto", // 禁用用户操作
        opacity: options.disabled ? 0.5 : 1, // 设置禁用时的透明度
      }}
    >
      <Picker.Column key={"data"} name={"data"}>
        {pickerData.data.map((option) => (
          <Picker.Item
            key={option} value={option}>
            {({ selected }) => (
              <div
                style={{
                  fontSize: selected ? "48px" : "36px",
                  color: selected ? "white" : "#fbbf84",
                }}
                className="font-bold"
              >
                {option}
              </div>
            )}
          </Picker.Item>
        ))}
      </Picker.Column>
    </Picker>
  );
}

export default SliderPicker;
